import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import { SuggestionProps } from "./types";
import SuggestionComparisonView from "./SuggestionComparisonView";

interface CampaignSuggestionGroupProps {
  campaignName: string;
  suggestions: SuggestionProps[];
}

const CampaignSuggestionGroup = ({
  campaignName,
  suggestions,
}: CampaignSuggestionGroupProps) => {
  return (
    <AccordionItem>
      <h2>
        <AccordionButton py={3}>
          <Box flex="1" textAlign="left" fontWeight="medium">
            {campaignName}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        {suggestions.map((suggestion) => (
          <SuggestionComparisonView
            key={suggestion.id}
            {...suggestion}
          />
        ))}
      </AccordionPanel>
    </AccordionItem>
  );
};

export default CampaignSuggestionGroup; 